define('app-CruiseExcursions/main',["./settings", "knockout", "moment", '../app/ui/dialog', '../app-blazy/module', "lightbox2", "moment-range", "jquery-ui"], function (settings, ko, moment, dialog, blazy) {
    return {
        run: function () {
            console.log('travel portal');
            var summary = $(settings.container),
                infoBox = $(settings.infoBox);

            if (summary.length === 0) {
                window.log("Summary will not be available.");
                return;
            }

            window.log("Loading Excursions");

            var totalExtras = 0,
                totalCost = 0,
                showMultiSelectMsg = true,
                extrasOnSale = false,
                bookingNumber = summary.data("booking-number");

            $.ajaxSetup({
                cache: false
            });
           
            function heartbeat() {
                $.ajax({
                    url: "/services/Shorex/Heartbeat.ashx?sid=" + Math.random(),
                    cache: false,
                    type: "GET",
                    dataType: "html"
                });
            }

            function makeReservationClick() {
                heartbeat();

                if (totalExtras > 0) {
                    var interval;
                    dialog.show();
                    $('.modal-header').addClass('hideClose');
                    clearTimeout(interval);
                    setTimeout(function () { makeReservation(); }, 1000);
                } else {
                    clearEmptyBasket();
                }
            }

            function clearEmptyBasket() {
                var jsonData = [],
                    params = {
                        "data": JSON.stringify(jsonData),
                        "itemType": "Excursion",
                        "bookingNumber": bookingNumber
                    };

                $.ajax({
                    type: "POST",
                    url: "/services/Shorex/ReserveExtras.ashx?sid=" + Math.random(),
                    data: params,
                    cache: false,
                    dataType: "json",
                    success: function (msg) {
                        msg == "false"
                            ? showErrorMessage()
                            : showMessageDialog("Sorry", "In order to continue you must select at least one Excursion");
                    },
                    error: function () {
                        showErrorMessage();
                    }
                });
            }

            function makeReservation() {
                var jsonData = [],
                    basketItem,
                    handleError = function () {
                        hidePopUp();
                        showErrorMessage();
                    };

                extras.forEach(function(item) {
                    if (item.SelectedPassengerNos.length > 0) {
                        basketItem = {
                            "Description": item.Name,
                            "NetAmount": item.Price.toFixed(2),
                            "ItemType": "Excursion",
                            "Code": item.Code,
                            "StartDateTime": moment(item.FromDate).format("YYYY-MMM-DD"),
                            "EndDateTime": moment(item.ToDate).format("YYYY-MMM-DD"),
                            "PassengerNumbers": item.SelectedPassengerNos,
                            "ItineraryCode": item.ItineraryCode,
                            "AllocationId": item.AllocationId
                        };

                        jsonData.push(basketItem);
                    }
                });

                if (jsonData.length > 0) {
                    var params = {
                        "data": JSON.stringify(jsonData),
                        "itemType": "Excursion",
                        "bookingNumber": bookingNumber
                    };

                    $.ajax({
                        type: "POST",
                        url: "/Services/Shorex/ReserveExtras.ashx?sid=" + Math.random(),
                        data: params,
                        cache: false,
                        dataType: "json",
                        success: function (msg) {
                            msg == "false"
                                ? handleError()
                                : window.location.href = $("#btnContinueRunningTotal").attr("href");
                        },
                        error: function () {
                            handleError();
                        }
                    });
                } else {
                    handleError();
                }
            };

            function showErrorMessage() {
                $("html, body").animate({
                    scrollTop: $(".pageContent").offset().top
                }, 1000, function () {
                    $("#ErrorMessage").slideDown(750);
                });
            };

            function createSummaryTable(type) {
                var total = 0;
                $("#SummaryExcursionBody").empty();

                extras.forEach(function(item) {

                    var valueToCheck = type === "booked"
                        ? item.AllocatedPassengerNumbers
                        : item.SelectedPassengerNos;

                    if (valueToCheck.length > 0) {
                        total++;

                        var tdDate = $("<td />", {
                            "class": "date",
                            "html": createDateHtml(moment(item.FromDate),moment(item.ToDate))
                        });
                        var tdExtra = $("<td />", { "class": "extra" });
                        var extraLink = $("<a />", {
                            "href": "javascript:void(0)",
                            "text": item.Name,
                            "style": "font-weight: bold;",
                            "class": "excursion-link",
                            "data-linked-excursion-id": item.ExcursionId,
                            "data-linked-group-id": item.ExcursionGroupId
                        });

                        var durationText = "<br/>" + item.DurationText;

                        extraLink.appendTo(tdExtra);
                        tdExtra.append(durationText);

                        var tdPrice = $("<td />", { "class": "price", "html": item.Price == 0 ? "no charge" : "&pound;" + item.Price }),
                            tdPassengers = $("<td />", { "class": "passenger", "text": " " }),
                            passengersList = $("<ul />");

                        valueToCheck.forEach(function(selectedNo) {
                            extraPassengers.forEach(function(passenger) {
                                if (passenger.PassengerNumber == selectedNo) {
                                    var passengertxt = $("<li />", { "text": passenger.FullName });
                                    passengertxt.appendTo(passengersList);
                                }
                            });
                        });

                        passengersList.appendTo(tdPassengers);

                        var row = row = $("<tr />");
                        tdDate.appendTo(row);
                        tdExtra.appendTo(row);
                        tdPrice.appendTo(row);
                        tdPassengers.appendTo(row);
                        row.appendTo($("#SummaryExcursionBody"));
                    }
                });

                if (type === "booked") {
                    $("#BookedPrintTBody").empty();

                    if (total > 0) {
                        $("#BookedPrintTBody").html($("#SummaryExcursionBody").html());
                        $("#BookedPrintTBody a").contents().unwrap();
                        return true;
                    } else {
                        $("#BookedPrintTBody").html("<h3>You currently have no excursions booked.</h3>");
                        return false;
                    }
                } else {
                    return total > 0;
                }
            }
         
            function calculateCost() {
                totalExtras = 0;
                totalCost = 0;

                extras.forEach(function (item) {
                    if (item.SelectedPassengerNos.length > 0) {
                        totalCost = totalCost + (item.Price * item.SelectedPassengerNos.length);
                        totalExtras += item.SelectedPassengerNos.length;
                    }
                });

                $(".RunningTotalSubTable .extrasTotal").html(totalExtras);
                $(".RunningTotalSubTable .extrasCost").html("&pound;" + totalCost);
                $("#infoBox .runningTotalTable .extrasTotal").html(totalExtras);
                $("#infoBox .runningTotalTable .extrasCost").html("&pound;" + totalCost);
                $("#SummaryRunningTotal").html("Sub Total: &pound;" + totalCost);

                totalExtras > 0
                    ? $(infoBox).slideDown()
                    : $(infoBox).slideUp();
            };

            function showMessageDialog(title, msg) {
                $("#MessageDialog p").text(msg);
                var d = $("#MessageDialog p").clone();
                dialog.show(title, d, null);
            }

            function showSummaryDialogue(title, showPrint, showTotal) {
                $("#SummaryPrintButton").hide();
                $("#SummaryTotalDiv").hide();

                if (showPrint)
                    $("#SummaryPrintButton").show();
                
                if (showTotal)
                    $("#SummaryTotalDiv").show();
                
                var d = $("#SummaryDialog").clone();
                d.show();
                $(d.find("#summaryClose")).hide();

                dialog.show(title, d, {
                    modal: true,
                    draggable: false,
                    resizable: false
                });
                $('.modal-dialog').addClass('modal-xl');
                
            }

            function dateCheck(selectedDate, durationBreak, startDate, endDate) {
                var range = moment().range(moment(startDate), moment(endDate)),
                    lookupDate = moment(selectedDate).add({ minutes: durationBreak }).subtract({ seconds: 1 });

                return range.contains(lookupDate);              
            }

            function isConflict(excursionId, guid, excursionStartDate, excursionEndDate, passengerNo) {
                var conflicts = [];

                extras.forEach(function(item) {
                    //Ignore if it is the same excursion with multiple times as they are treated like radio buttons i.e. only one can be selected
                    if (item.Guid != guid && item.ExcursionId != excursionId) {
                        var conflict = false,
                            // if passenger already selected for this excursion or already booked for this excursion
                            selected = $.inArray(parseInt(passengerNo), item.SelectedPassengerNos) > -1 || $.inArray(parseInt(passengerNo), item.AllocatedPassengerNumbers) > -1;
                      
                        if (selected) {
                            conflict = dateCheck(excursionStartDate, item.DurationBetweenShorex, item.FromDate, item.ToDate);

                            if (!conflict)
                                conflict = dateCheck(excursionEndDate, item.DurationBetweenShorex, item.FromDate, item.ToDate);
                            
                            if (!conflict)
                                conflict = dateCheck(item.FromDate, item.DurationBetweenShorex, excursionStartDate, excursionEndDate);
                            
                            if (!conflict)
                                conflict = dateCheck(item.ToDate, item.DurationBetweenShorex, excursionStartDate, excursionEndDate);
                            
                            if (conflict)
                                conflicts.push(item.Name);                            
                        }
                    }
                });

                return conflicts;              
            }

            function createDateHtml(fromDate, toDate) {
                return fromDate.format("D MMM YYYY") == toDate.format("D MMM YYYY")
                    ? fromDate.format("D MMM YYYY") + "<br/>" + fromDate.format("HH:mm") + " - " + toDate.format("HH:mm")
                    : fromDate.format("D MMM YYYY HH:mm") + "<br/>" + toDate.format("D MMM YYYY HH:mm")
            }

            function UpdateAvailability(excursionId) {
                var excursion = extras.filter(function (extra) {
                    return extra.ExcursionId == excursionId;
                })[0];
                if (excursion && excursion.Availability <= 10) {
                    var availabilityCounter = $("#" + excursion.ExcursionId).find(".availability-count");
                    if (availabilityCounter) {
                        var availability = excursion.Availability - excursion.SelectedPassengerNos.length;
                        availabilityCounter.html(availability === 1 ? "1 space" : availability + " spaces");
                    }                  
                }                
            };

            function addPassenger(checkbox) {   
                var updateCheckbox = false,
                    allocationGuid = $(checkbox).attr("data-allocation-guid"),
                    excursionId = $(checkbox).attr("data-excursion-id"),
                    passengerNo = parseInt($(checkbox).attr("data-passengerNo")), 
                    hasMultipleAllocations = $(checkbox).data("multiple-allocations").toLowerCase();

                extras.forEach(function(item) {
                    if (item.Guid == allocationGuid) {
                        //If the customer is already selected, remove them from the excursion
                        if (item.SelectedPassengerNos.includes(passengerNo)) {
                            item.SelectedPassengerNos.splice($.inArray(parseInt(passengerNo), item.SelectedPassengerNos), 1);
                            showMultiSelectMsg = false;
                        }
                        //Check item availability
                        else {
                            if (item.Availability > 0 && item.OnSale) {
                                //If availability has already been selected by other passengers...
                                if (item.Availability == item.SelectedPassengerNos.length) {
                                    showMessageDialog("Sorry", "All available spaces on this excursion have been selected.");
                                } else {
                                    var conflicts = isConflict(item.ExcursionId, item.Guid, item.FromDate, item.ToDate, passengerNo);
                                    if (conflicts.length > 0) {
                                        showMessageDialog("Selection Conflict", "Sorry, you are unable to select this excursion as the time conflicts with an excursion already booked or selected (" + conflicts[0] + ")");
                                    } else {
                                        item.SelectedPassengerNos.push(parseInt(passengerNo));
                                        updateCheckbox = true;
                                        //If belongs to the same excursion, remove them from the previous allocation
                                        if (hasMultipleAllocations === 'true') {
                                            extras.forEach(function (item) {
                                                if (item.ExcursionId == excursionId && item.SelectedPassengerNos.includes(passengerNo) && item.Guid != allocationGuid) {
                                                    item.SelectedPassengerNos.splice($.inArray(parseInt(passengerNo), item.SelectedPassengerNos), 1);
                                                    $("input[value=" + item.AllocationId + "-" + passengerNo + "]").prop("checked", false);
                                                }
                                            });
                                        } 

                                        if (totalExtras > 0)
                                            showMultiSelectMsg = false;                                        

                                        if (showMultiSelectMsg) {
                                            showMultiSelectMsg = false;
                                            showMessageDialog("Passenger Selected", multiSelectMsg);
                                        };
                                    }
                                }                              
                            } else {
                                showMessageDialog("Sorry", fullyBookedMsg);
                            }
                        }

                        return false;
                    }
                });

                $(checkbox).prop("checked", updateCheckbox);
                UpdateAvailability(excursionId);
                calculateCost();
            };

            function ViewBookedExcursions(e) {
                e.preventDefault();
                var bookedExcursionsToggle = $('#booked-excursions a.accordion-toggle'),
                    bookedExcursionsToggleOffset = bookedExcursionsToggle.offset().top;

                if (!$('#booked-excursions-accordion').is(":visible")) 
                    bookedExcursionsToggle.click();
                
          
                $('html, body').animate({ scrollTop: bookedExcursionsToggleOffset }, 1000);
            }

           /*EVENT BINDING*/

            //Trigger heartbeat when accordions are used
            $(document).on("shown.bs.collapse hidden.bs.collapse", heartbeat);

            //Initialise tooltips for label icons
            $(function () {
                $('[data-toggle="tooltip"]').tooltip({
                    "offset": '5, 20',
                    "template": "<div class='tooltip atlas-tooltip' role='tooltip'><div class='arrow'></div><div class='tooltip-inner'></div></div>"
                })
            });

            $("#view-booked-excursions").on("click", ViewBookedExcursions);

            $("#btnContinueRunningTotal").on("click", function (event) {
                event.preventDefault();
                makeReservationClick();
            });

            blazy.loadLazy();

            //Sort description height
            $('.accordion-group').on('shown.bs.collapse', function () {
                var currentOpen = $(this);
                $(".description", currentOpen).each(function () {
                    var descriptionHeight = $(this).find("span").height(),
                        ems = 0.0555,
                        converted = descriptionHeight * ems;
                    if (converted > 4) {
                        $('.showHide', this).show();
                        $(this).find("span").addClass('collapse');
                    }
                });
            }).on('show.bs.collapse', function () {
                blazy.loadLazy();
            });

            $("#btnViewSelected, #btnViewBooked").on("click", function (event) {
                event.preventDefault();
                var summaryType = event.target.dataset.summaryType,
                    showSummary = createSummaryTable(event.target.dataset.summaryType)

                switch (summaryType) {
                    case "booked":
                        if (showSummary) {
                            var url = window.location.href + ("?&sc_device=Print");
                            window.open(url);
                        } else {
                            showMessageDialog("Booked Excursions Summary", "You currently have no excursions booked");
                        }
                        break;
                    case "selected":
                        showSummary
                            ? showSummaryDialogue("Selected Excursions Summary", false, true)
                            : showMessageDialog("Selected Excursions Summary", "You currently have no excursions selected");
                        break;
                }
            });

            //Scroll to excursion when clicked in the summary table
            $(document).on("click", ".excursion-link", function (e) {
                var excursionId = e.currentTarget.dataset.linkedExcursionId,
                    groupId = e.currentTarget.dataset.linkedGroupId,
                    collapsedContent = $("#ID-" + groupId);

                if (!collapsedContent.is("visisble"))
                    $(collapsedContent).collapse("show");
                
                $("html, body").animate({
                    scrollTop: $("#" + excursionId + " h3").offset().top - 10 }, 500, function () {
                        dialog.closeAll();
                    });
            });     

            $(document).ready(function () {
                extrasOnSale = extras.filter(function (extra) {
                    return extra.OnSale
                }).length > 0;                

                $("input[data-allocation-guid]").on("change", function () {
                    heartbeat();
                    addPassenger(this);
                });

                $(".jqueryButton").button();        

                if ($("#infoBox").length > 0)
                    $(".navigation").append($("#infoBox"));

                calculateCost();

                extrasOnSale ? $("#InfoBoxExtrasTotal").show() : $("#InfoBoxNoExtrasTotal").show();
            });

            $(".extraTable").each(function () {
                $(this).find("tr").last().remove();
            });

            createSummaryTable("booking");

            ko.applyBindings(this, $("#main")[0]);
        }
    };
});
